import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

const ClaimLoader = () => (
  <div role="status" className="min-h-[20rem] flex items-center justify-center gap-4 text-xl font-semibold text-sas">
    <FontAwesomeIcon icon={faSpinner} spin className="text-3xl" />
    <span>Loading...</span>
  </div>
)

export default ClaimLoader
